/**
 * Created by maofaming on 2017/4/27.
 */
import q from 'q';
import QuRequest from '@/core/QuRequest';
// import ClassifyOptimize from '../widget/ClassifyOptimize.vue'
// import { debug } from 'util';

const quRequest = new QuRequest();

const _CONTENTTYPE = {
    6: {
        id: 'atlasId',
        contentType: 1
    },
    1: {
        id: 'articleId',
        contentType: 2
    },
    2: {
        id: 'videoId',
        contentType: 3
    }
};

export default {
    created () {
        this.filter = this.$queryFilter();
        // console.log(this.filter, this.$route)
        this.$updateRouter(this.filter);
    },
    data () {
        return {
            totalPageSize: 0,
            totalCount: 0,
            isMergeCategory: false, // 是否聚合分类
            isNewCategory: true, // 是否分类分组
            mergeCategoryList: [], // 聚合分类
            categoryList: [], // 分类分组
            stat: {}
        };
    },
    computed: {
        auditDateRange: {
            set (newValue) {
                if (newValue) {
                    this.filter.create_time_start = this.formatDate(newValue[0]);
                    this.filter.create_time_end = this.formatDate(newValue[1]);
                } else {
                    this.filter.create_time_start = '';
                    this.filter.create_time_end = '';
                }
            },
            get () {
                return [this.filter.create_time_start, this.filter.create_time_end];
            }
        }
    },
    methods: {
        handleCurrentChange (page) {
            // 点击分页时获取新数据
            this.filter.page = page;
            this.getList();
        },
        formatDate (dateStr) {
            // 格式化日期
            if (dateStr) {
                let date = new Date(dateStr);
                let y = date.getFullYear();
                let m = date.getMonth() + 1;
                let d = date.getDate();
                return [y, this.addZero(m), this.addZero(d)].join('/');
            } else {
                return '';
            }
        },
        addZero: function (num) {
            return (num > 9 ? '' : '0') + num;
        },
        search () {
            // 响应搜索事件
            this.filter.page = 1;
            this.getList();
        },
        toHistory (item) {
            // 去历史审核记录页面
            let targetType = this.filter.target_type;
            let contentId = '';
            if (_CONTENTTYPE[targetType]) {
                // 图集、视频、文章
                contentId = item[_CONTENTTYPE[targetType].id];
            } else {
                contentId = item.content_id;
            }
            window.open(
                `/auditmanage/audit-history-detail?content_id=${contentId}&target_type=${targetType}&page=1&page_size=30`,
                '_blank'
            );
        },
        clearAudit () {
            // 清除审核队列
            let that = this;
            this.$confirm('是否确认清空审核队列', '操作确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // that.api['clear']({})
                quRequest
                    .send(quRequest.Apis.qupost.contentReview.clear)
                    .then(res => {
                        this.$message({
                            message: '已清空审核队列',
                            type: 'success'
                        });
                    })
                    .catch(res => {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    });
            });
        },
        toReviewView (contentId) {
            // 复审跳转详情页
            this.$router.push({
                name: this.detailPathName,
                query: {
                    id: contentId,
                    auditEnter: 'search',
                    create_time_start: this.filter.create_time_start,
                    create_time_end: this.filter.create_time_end,
                    book_id: this.filter.book_id,
                    order: this.filter.order,
                    queue_level: this.filter.queue_level
                }
            });
        },
        toView (index) {
            // 去审核详情页面，带入id
            let obj = { id: index };
            if (Object.prototype.toString.call(index) === '[object Object]') {
                obj = index;
            }
            this.$router.push({ name: this.detailPathName, query: obj });
        },

        getList () {
            // 更新列表数据
            let filter = this.filter;
            this.$updateRouter(filter);
            this.loading = true;

            quRequest
                .send(quRequest.Apis.audit.contentreviewaudit.list, this.filter)
                .then(({ data }) => {
                    this.list = data.list || [];
                    this.totalPageSize = data.total || 0;
                })
                .catch(res => {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                })
                .fin(() => {
                    this.loading = false;
                });
        },
        getStatistics () {
            // 获取当日审核数据
            let param = {
                product_key: 'midu',
                app_key: 'story',
                queue_level: 1
            };
            // let data = {
            //   "todayAlready": 111,            //今日过审稿件
            //   "todayHighAlready": 111,            //高热召回队列过审稿件
            //   "todayHighRemain": 111,         //高热召回队列未审核稿件
            //   "currentRemain": 111,           //当前剩余未审核稿件
            //   "todayAdd": 111,            //今日新增待审核稿件
            // };
            // this.stat = data;

            quRequest
                .send(quRequest.Apis.audit.contentreviewaudit.statistics, param)
                .then(res => {
                    this.stat = res.data;
                    // this.disabled = false
                })
                .catch(res => {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                });
        },
        // 获取内容生产方
        listContentProducer () {
            return quRequest.send(this.quApi.listContentProducer);
        },
        // 获取聚合分类
        getMergeCategory () {
            let that = this;
            return quRequest.send(that.auditApi.getMergeCategory, { mergeCategory: 1, type: 'review' });
        },
        // 获取新分类
        getNewCategory () {
            let that = this;
            return quRequest.send(that.auditApi.getNewCategory, { mergeCategory: 1 });
        },
        // 分类对象转数组
        formatCategory (data = {}) {
            let array = [];
            for (let i in data) {
                let item = data[i];
                if (item.categoryId) {
                    array.push({
                        id: item.categoryId,
                        name: item.categoryName
                    });
                } else {
                    array.push(item);
                }
            }
            return array;
        },
        // 跳转审核详情
        toReview (item, flg) {
            let targetType = this.filter.target_type;
            let toDetail = '';
            let params = {
                auditEnter: 'record'
            };
            let appKey;
            if (targetType === '1') {
                // 文章    新加接口判断
                toDetail = 'UserArticleRecordDetail';
                params.id = item.articleId;
                appKey = 'article';
            } else if (targetType == '6') {
                // 图集
                toDetail = 'UserPictureRecordDetail';
                appKey = 'atlas';
                params.id = item.atlasId;
            } else if (targetType == '2') {
                // 视频
                toDetail = 'UserMediaRecordDetail';
                appKey = 'video';
                params.id = item.videoId;
            } else {
                toDetail = 'UserMediaRecordDetail';
                params.id = item.content_id;
            }
            if (flg) {
                // item.logId
                params = Object.assign(params, { logId: item.logId, appKey: appKey, logNode: item.node });
            }
            // this.$router.push({name: toDetail, query: params})
            let routes = this.$router.resolve({ name: toDetail, query: params });
            window.open(routes.href, '_blank');
        }
    },
    mounted () {
        // if(this.apiList){
        //     this.api = this.$httpFactory(this.apiList);
        // }

        this.getStatistics(); // 初始时获取审核信息
    }
};
